import { z } from 'zod';
/**
 * Public SPA bootstrap configuration served by GET /api/public/bootstrap.
 * Values are safe to expose to unauthenticated browsers.
 */
export const PublicBootstrapConfigSchema = z.object({
    apiBaseUrl: z.string().url(),
    locationApiBaseUrl: z.string().url(),
    publicAppUrl: z.string().url(),
    wsUrl: z.string().min(1),
    awsRegion: z.string().min(1),
    cognitoUserPoolId: z.string().min(1),
    cognitoClientId: z.string().min(1),
    /** Cognito hosted UI domain prefix (e.g. cci-insight-prod) for OAuth/PKCE. */
    cognitoOAuthDomain: z.string().min(1).optional(),
    appName: z.string().min(1),
    stripePublishableKey: z.string().optional(),
    realtimeSseEnabled: z.boolean(),
    efemLockTimeoutSeconds: z.number().int().positive(),
    fileUpload: z.object({
        maxSize: z.number().int().positive(),
        /** Comma-separated MIME patterns (e.g. `image/*,application/pdf`). */
        allowedTypes: z.string(),
    }),
});
export const PublicBootstrapResponseSchema = z.object({
    success: z.literal(true),
    message: z.string(),
    data: PublicBootstrapConfigSchema,
});
//# sourceMappingURL=bootstrap.schema.js.map